module.exports = __webpack_public_path__ + "static/media/wizualizacja-91.3b172dcb.png";